import { openModal } from 'app/components/Helpers/Dialog'
import { Dispatchable } from 'app/constants/GlobalTypes'
import { fetchPurchasingRequest } from 'app/redux/actions/PurchasingRequest'
import { destroyRentalRequestState } from 'app/redux/actions/RentalRequest'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

export const usePurchasingRequest = () => {
  const { purchasingRequest, fetching } = useSelector<AppState, RentalRequestReducerState>(
    (state) => state.rentalRequest
  )
  const dispatch = useDispatch<Dispatchable>()

  const { order_request_id, purchasing_request_id } = useParams<{
    order_request_id: string
    purchasing_request_id: string
  }>()

  // Temporary backwards compatibility for order requests
  const id = purchasing_request_id || order_request_id

  const { formatMessage } = useIntl()

  const fetch = useCallback(() => {
    const onError = (error: string[]) => {
      openModal(
        formatMessage({ id: 'error.default' }),
        error,
        formatMessage({ id: 'cancel' }),
        'error'
      )
    }

    dispatch(fetchPurchasingRequest(Number(id))).catch(onError)
  }, [id])

  const destroyState = () => {
    // Resets to initial state
    dispatch(destroyRentalRequestState())
  }

  return {
    purchasingRequest,
    fetching,
    fetch,
    destroyState
  }
}
